import React from "react";


export default function RestlessReportContent(cellContent) {
  return (
    <div>
      {cellContent}
    </div>
  );
}
